import {NavigationTabsModuleTabModel} from "../navigation-tabs-module.tab-model";
import type {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import type {EntityViewModel} from "../../../../../infrastructure/models/entity/entity.view-model";
import {ANALYTICS} from "../../../../../third-party-services/analytics/analytics-consts";
import {CompetitionMatchesPageLinkModel} from "../../../../../containers/competition-container/pages/matches-page/models/competition-matches-page.link-model";

export class NewMatchesFilterTabModel extends NavigationTabsModuleTabModel {
  index: Number;
  name: String;
  entity: EntityViewModel;
  currentLinkModel: BaseLinkModel;
  linkModelType: String;
  isWidget: String;

  constructor(
    index: Number,
    name: String,
    entity: EntityViewModel,
    currentLinkModel: BaseLinkModel,
    linkModelType: BaseLinkModel,
    isWidget: boolean
  ) {
    super(index, name)

    this.entity = entity;
    this.currentLinkModel = currentLinkModel;
    this.linkModelType = linkModelType;
    this.isWidget = isWidget;
  }

  get analyticsEntityType(): Object {
    return this.linkModelType === CompetitionMatchesPageLinkModel ? ANALYTICS.ENTITY_TYPES.competition : ANALYTICS.ENTITY_TYPES.competitor;
  }

}
